import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Message } from "primeng/primeng";
import { Globals } from "../../../../../globals/Globals";
import { HttpService } from "../../../../../services/http.service";

declare let $: any;

@Component({
  selector: "app-save-template",
  templateUrl: "./save-template.component.html",
  styleUrls: ["./save-template.component.css"]
})
export class SaveTemplateComponent {
  msgs: Message[] = [];
  pagesArray = [];
  imageImage = [];
  objOfImg = {};
  isLoadedimage;

  @Input() templateName;
  @Input() templateIDInfo;
  @Input() allPages;
  @Input() templateData;
  @Input() templateType;
  @Input() allFonts;

  @Output() onSave = new EventEmitter<any>();

  constructor(private uploadFileService: HttpService) {}

  saveTemplate() {
    this.isLoadedimage = true;
    this.pagesArray = [];
    const allPages = $(".parentBlock").find("a");
    for (let i = 0; i < allPages.length; i++) {
      allPages[i].style.pointerEvents = "all";
    }
    if (this.templateName !== "") {
      this.removeImagesSrc();
      this.removeUnusedFonts();
      this.stringifyTemplates();
      const requestBody = {
        id: this.templateIDInfo.id,
        clientId: this.templateIDInfo.clientId,
        defTemplateId: this.templateType,
        name: this.templateName,
        views: this.pagesArray
      };

      this.uploadFileService.updateTemplate(requestBody).subscribe(
        (res: any) => {
          // if (res.status === 'OK') {
          // this.pagesArray = [];
          this.onSave.emit();
          this.imageImage = [];
          this.refreshImages();
          this.isLoadedimage = false;
          if (res.result === Globals.RESPONSE_RESULT_SUCCESS) {
            this.showMessage("success", "Success", "Template has been updated");
          } else {
            this.showMessage("error", "Error", res.payload);
          }
          // }
        },
        error => {
          // this.onSave.emit({severity: 'error', summary: 'Error', detail: 'Internal server error'});
          this.showMessage("error", "Error", "Template has not been updated");
          this.pagesArray = [];
        }
      );
    } else {
      // this.onSave.emit({severity: 'error', summary: 'Error', detail: 'Internal server error'});
      this.showMessage("error", "Error", "Template has not been updated");
      this.pagesArray = [];
    }
  }

  removeUnusedFonts() {
    const allTexts = $(".parentBlock").find("p, label, .bodytext, .cpt-button");
    let usedFonts = [];
    for (let i = 0; i < allTexts.length; i++) {
      if (usedFonts.length === 0) {
        usedFonts.push(allTexts[i].style.fontFamily);
      } else if (usedFonts.indexOf(allTexts[i].style.fontFamily) === -1) {
        usedFonts.push(allTexts[i].style.fontFamily);
      }
    }
    const filteredFonts = this.allFonts.filter(font => {
      if (usedFonts.indexOf(font.fileName) > -1) {
        return true;
      } else {
        return false;
      }
    });
    let createdStyle = "";
    for (let i = 0; i < filteredFonts.length; i++) {
      if (createdStyle.length === 0) {
        createdStyle += '<style class="style">';
      } else if (filteredFonts.length === i) {
        createdStyle += "</style>";
        break;
      }

      createdStyle += `@font-face {font-family: "${
        filteredFonts[i].fileName
      }";src: url("${
        filteredFonts[i].fontUrl
      }") format("woff2"),url("${
        filteredFonts[i].fontUrl
      }") format("woff");}`;
    }
    let addStyle: any = document.querySelectorAll("#cp");
    let style = document.querySelectorAll(".style");

    for (let i = 0; i < addStyle.length; i++) {
      if ($(addStyle[i]).children(".style").length > 0) {
        for (let i = 0; i < style.length; i++) {
          addStyle[i].removeChild(style[i]);
        }
      }
      addStyle[i].innerHTML += createdStyle;
    }
  }
  removeImagesSrc() {
    const allImgArray = [].slice.call(
      document.querySelectorAll(
        "#content_image, #login_image_id_1, #login_image_id_2, #logo_id, #ad_img_id_1 #ad_img_id_2 #ad_img_id_3 #ad_img_id_4 #ad_img_id_5 #ad_img_id_6"
      )
    );
    $("#login_iframe_id_2 #remove_id_2").css("display", "none");
    $("#login_iframe_id_1 #remove_id_1").css("display", "none");
    // $().replaceAll("#remove_id_2");
    // $().replaceAll("#remove_id_1");
    for (let i = 0; i < allImgArray.length; i++) {
      if (allImgArray[i].hasAttribute("src")) {
        allImgArray[i].removeAttribute("src");
        // $(allImgArray[i]).attr('src', '');
        // console.log("REMOVING", allImgArray[i]);
      }
    }
  }

  refreshImages() {
    const allImgSrc = document.querySelectorAll(
      "#content_image, #login_image_id_1"
    );
    for (let i = 0; i < allImgSrc.length; i++) {
      if (!allImgSrc[i].hasAttribute("src")) {
        allImgSrc[i].setAttribute("src", `${this.imageImage[i]}`);
        console.log(this.imageImage[i]);
      }
    }
    // console.log("REFRESHED IMAGES");
  }

  stringifyTemplates() {
    for (let i = 0; i < this.allPages.length; i++) {
      for (let j = 0; j < this.templateData.views.length; j++) {
        if (
          this.allPages[i].getAttribute("class") ===
          this.templateData.views[j].viewId
        ) {
          this.pagesArray.push({
            viewId: this.templateData.views[j].viewId,
            viewName: this.templateData.views[j].viewName,
            innerHTML: JSON.stringify(this.allPages[i].outerHTML),
            withVideo: this.templateData.views[j].withVideo
          });
        }
      }
    }
    // console.log("stringified array", this.pagesArray);
  }

  showMessage(type, summary, detail) {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summary, detail: detail });
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/captive-portal/shared/save-template/save-template.component.ts